import { render, staticRenderFns } from "./detailUserContact.vue?vue&type=template&id=1c9ca3d2"
import script from "./detailUserContact.vue?vue&type=script&lang=js"
export * from "./detailUserContact.vue?vue&type=script&lang=js"
import style0 from "./detailUserContact.vue?vue&type=style&index=0&id=1c9ca3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports